import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TestResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { result } = location.state || {};

  if (!result) {
    navigate("/test");
    return null;
  }

  // Calculate score
  const totalQuestions = result.answers.length;
  const correctAnswers = result.answers.filter(
    (answer) => answer.isCorrect
  ).length;
  const score = Math.round((correctAnswers / totalQuestions) * 100);

  return (
    <div className="min-h-screen bg-dark-bg text-white p-4 sm:p-8">
      <div className="max-w-4xl mx-auto">
        {/* Score Summary */}
        <div className="bg-dark-card rounded-xl p-6 mb-8">
          <h1 className="text-2xl font-bold mb-4">Test Results</h1>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-400">Score</p>
              <p className="text-4xl font-bold text-blue-500">{score}%</p>
            </div>
            <div>
              <p className="text-gray-400">Correct Answers</p>
              <p className="text-xl">
                {correctAnswers} / {totalQuestions}
              </p>
            </div>
          </div>
        </div>

        {/* Detailed Results */}
        <div className="space-y-4">
          {result.answers.map((answer, index) => (
            <div
              key={index}
              className={`bg-dark-card rounded-xl p-6 ${
                answer.isCorrect ? "border-green-500" : "border-red-500"
              } border-l-4`}
            >
              <p className="text-lg font-medium mb-4">{answer.question}</p>
              <div className="space-y-2">
                <p>
                  <span className="text-gray-400">Your Answer: </span>
                  <span
                    className={
                      answer.isCorrect ? "text-green-500" : "text-red-500"
                    }
                  >
                    {answer.answer || "No answer provided"}
                  </span>
                </p>
                {!answer.isCorrect && (
                  <p>
                    <span className="text-gray-400">Correct Answer: </span>
                    <span className="text-green-500">
                      {answer.correctAnswer}
                    </span>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="mt-8 flex justify-between">
          <button
            onClick={() => navigate("/test")}
            className="px-6 py-2 bg-dark-card text-white rounded-lg hover:bg-opacity-80"
          >
            Back to Tests
          </button>
          <button
            onClick={() => navigate("/test/create")}
            className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Create New Test
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestResults;
